import { createFileRoute, notFound } from "@tanstack/react-router";
import { ArticlePage, ArticleNotFound, articleHead } from "@/pages/ArticlePage";
import { findPostBySlug } from "@/data/blog/posts";

export const Route = createFileRoute("/en/articles/$slug")({
  loader: ({ params }) => {
    const post = findPostBySlug(params.slug, "en");
    if (!post) throw notFound();
    return { post };
  },
  head: ({ loaderData }) =>
    loaderData ? articleHead(loaderData.post, "en") : { meta: [{ title: "Articles | MI Support" }] },
  notFoundComponent: () => <ArticleNotFound locale="en" />,
  component: RouteComponent,
});

function RouteComponent() {
  const { post } = Route.useLoaderData();
  return <ArticlePage post={post} locale="en" />;
}
